const hoverNav = () => {
  const COLLECTION_INFO = {
    activeClass: 'active',
    dataHover: '[data-btn]',
    dataSubHover: '[data-btn-lvl2]',
    dataList: '[data-btn-list]',
    dataWrapperList1: '[data-wrapper-list="lvl1Main"]',
    dataWrapperList2: '[data-wrapper-list="lvl2Main"]',
    dataWrapperList3: '[data-wrapper-list="lvl3Main"]',
    timeOut: 100,
  };
  const hoverWrapperAll = document.querySelectorAll(COLLECTION_INFO.dataHover);
  const listWrapperAll = document.querySelectorAll(COLLECTION_INFO.dataList);
  const wrapperLvl1 = document.querySelector(COLLECTION_INFO.dataWrapperList1);
  const wrapperLvl2 = document.querySelector(COLLECTION_INFO.dataWrapperList2);
  const wrapperLvl3 = document.querySelector(COLLECTION_INFO.dataWrapperList3);
  const navBg = document.querySelector('.navShop');

  const keys = {};

  listWrapperAll.forEach((item) => {
    keys[item.dataset.btnList] = item;
  });


  const desctop = () => {
    const addBg = () => {
      navBg.classList.add(COLLECTION_INFO.activeClass);
    };
    const removeBg = () => {
      navBg.classList.remove(COLLECTION_INFO.activeClass);
    };
    const addActive = (key) => {
      keys[key].classList.add(COLLECTION_INFO.activeClass);
    };
    const removeActive = (key) => {
      keys[key].classList.remove(COLLECTION_INFO.activeClass);
    };
    const setPositionLvl2 = (position) => {
      wrapperLvl2.style.left = `${position.left - 16}px`;
    };
    const setPositionLvl3 = (left, width) => {
      wrapperLvl3.style.left = `${left + width}px`;
    };
    let deb = null;

    const addDeb = () => {
      clearTimeout(deb);
      addBg();
    };
    const removeDeb = () => {
      deb = setTimeout(removeBg, 100);
    };

    [wrapperLvl1, wrapperLvl2, wrapperLvl3].forEach((item) => {
      item.addEventListener('mouseover', addDeb);
      item.addEventListener('mouseout', removeDeb);
    });

    hoverWrapperAll.forEach((button) => {
      let debounce = null;
      const dataKey = button.dataset.btn;
      const element = keys[dataKey];

      const listBtnLvl2 = element.querySelectorAll('.navShop__lvl2Link');

      const clearDepLvl1 = () => {
        clearTimeout(debounce);
      };
      const addDepLvl1 = () => {
        debounce = setTimeout(() => {
          removeActive(dataKey);
        }, COLLECTION_INFO.timeOut);
      };

      button.addEventListener('mouseover', (e) => {
        addActive(dataKey);
        clearDepLvl1();
        setPositionLvl2(button.getBoundingClientRect());
      });
      button.addEventListener('mouseout', (e) => {
        addDepLvl1();
      });
      element.addEventListener('mouseover', (e) => {
        clearDepLvl1();
      });
      element.addEventListener('mouseout', (e) => {
        addDepLvl1();
      });
      listBtnLvl2.forEach((btnLvl2) => {
        const dataLvl2Key = btnLvl2.dataset.btnLvl2;
        let debounceLvl2 = null;
        if (dataLvl2Key) {
          const elementLvl2 = keys[dataLvl2Key];
          btnLvl2.addEventListener('mouseover', (e) => {
            addActive(dataLvl2Key);
            clearTimeout(debounceLvl2);
            setPositionLvl3(btnLvl2.getBoundingClientRect().left, btnLvl2.offsetWidth);
          });
          btnLvl2.addEventListener('mouseout', (e) => {
            debounceLvl2 = setTimeout(() => {
              removeActive(dataLvl2Key);
            }, 0);
          });

          elementLvl2.addEventListener('mouseover', (e) => {
            clearTimeout(debounceLvl2);
            clearDepLvl1();
          });
          elementLvl2.addEventListener('mouseout', (e) => {
            addDepLvl1();
            debounceLvl2 = setTimeout(() => {
              removeActive(dataLvl2Key);
            }, 0);
          });
        }
      });
    });
  };

  const mobile = () => {
    const closeBtn = document.querySelector('.navShop__close');
    const subBtns = document.querySelectorAll(COLLECTION_INFO.dataSubHover);
    const btnTitle = document.querySelector('.navShop__lvl3MainTitle');
    const clossOllBtns = () => hoverWrapperAll.forEach((item) => item.classList.remove('active'));
    const closeOllPage = () => listWrapperAll.forEach((item) => item.classList.remove('active'));
    const bodyBlock = document.querySelector('body');
    const openFunk = (key) => {
      closeOllPage();
      keys[key].classList.add('active');
    };
    const openBtn = (btn) => {
      clossOllBtns();
      btn.classList.add('active');
    };
    const openLvl3 = () => {};
    const openLvl3Full = () => {
      wrapperLvl2.classList.add('hide');
      wrapperLvl3.classList.remove('hide');
    };
    hoverWrapperAll.forEach((btn) => {
      const btnKey = btn.dataset.btn;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openFunk(btnKey);
        openBtn(btn);
      });
    });
    subBtns.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        const btnKey = btn.dataset.btnLvl2;
        if(btnKey){
          event.preventDefault()
          btnTitle.innerHTML = btn.querySelector('.navShop__lvl2Title').innerHTML
          btnTitle.dataset.key = btn.closest('.navShop__lvl2List').dataset.btnList
        }
        openLvl3Full();
        openFunk(btnKey);
      });
    });
    
    navBg.addEventListener('click', (e) => {
      if (e.target.classList.contains('navShop')) {
        navBg.classList.remove('active');
        bodyBlock.classList.remove('locked');
      }
    });
    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      navBg.classList.remove('active');
      bodyBlock.classList.remove('locked');
    });

    
    document.querySelectorAll('.header__btnMenu').forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        navBg.classList.add('active');
        bodyBlock.classList.add('locked');
        
      });
    });
    btnTitle.addEventListener('click', (e) => {
      e.preventDefault();
      wrapperLvl2.classList.remove('hide');
      wrapperLvl3.classList.add('hide');

      openBtn(document.querySelector(`[data-btn="${btnTitle.dataset.key}"]`));
      openFunk(btnTitle.dataset.key);
    });

    openBtn(document.querySelector(`[data-btn="${listWrapperAll[0].dataset.btnList}"]`));
    openFunk(listWrapperAll[0].dataset.btnList);
    closeBtn.style.left = `${wrapperLvl1.offsetWidth}px`;
    window.addEventListener('resize', (e) => {
      closeBtn.style.left = `${wrapperLvl1.offsetWidth}px`;
    });
  };

  if (window.innerWidth < 998) {
    mobile();
  } else {
    desctop();
  }
};

const init = () => {
  hoverNav();
};

window.addEventListener('DOMContentLoaded', init);
